'use strict';

export const providerIntents = {
  configuration: 'configuration',
  shop: 'shop',
  pricing: 'pricing',
  manage: 'manage',
  checkout: 'checkout',
  thankyou: 'thankyou',
};

export const storePubSub = {
  refreshCart: 'REFRESH_CART',
  checkoutState: 'CHECKOUT_STATE',
  checkout: 'STORE_CHECKOUT'
};


// WEBPACK FOOTER //
// ./store/applications/consts.js